export interface FeatureLimitValidationItem {
  code: string;
  supportsLimit?: boolean;
  supportsDailyLimit?: boolean;
}

export const DAILY_EXCEEDS_CYCLE_MESSAGE = 'Daily limit cannot exceed the billing-cycle limit';

export function validateFeatureLimits(
  features: FeatureLimitValidationItem[],
  limits: Record<string, number | null>,
  dailyLimits: Record<string, number | null>
): Record<string, string> {
  const errors: Record<string, string> = {};

  for (const feature of features) {
    if (!feature.supportsDailyLimit) {
      continue;
    }

    const limit = limits[feature.code];
    const dailyLimit = dailyLimits[feature.code];
    if (limit !== null && limit !== undefined && dailyLimit !== null && dailyLimit !== undefined) {
      if (dailyLimit > limit) {
        errors[feature.code] = DAILY_EXCEEDS_CYCLE_MESSAGE;
      }
    }
  }

  return errors;
}
